export const EstaticosData = [
  {
    primeiroNome: '_ga',
    segundoNome: '.maersk.com',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site para fins de análise e geração de relatórios.',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: '.www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: 'www.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: '.maersk.com',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: '.beta.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: '.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga',
    segundoNome: '.maersk.com.cn',
    finalidade:
      'Coleta informações sobre os usuários e suas atividades no site para fins de análise e geração de relatórios.',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: 'beta.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: '.www.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
  {
    primeiroNome: '_ga_xxx',
    segundoNome: 'www.maersk.com.cn',
    finalidade: '',
    validade: 'um ano',
    processadorDados: 'Google Analytics',
    linkPolitica:
      'https://policies.google.com/technologies/partner-sites?hl=en',
  },
]
